import(/* webpackMode: "eager" */ "/microservice/src/app/[locale]/not-found.tsx");
